import { useClickAwayModal } from 'hooks';

import { CalendarModal } from './modal';
import { CalendarProps } from './types';
import { CurrentWeek } from './current-week';

export const Calendar = ({ week, onChange }: CalendarProps) => {
  const { callerRef, modalRef, isOpen, setIsOpen } = useClickAwayModal();

  return (
    <div style={{ position: 'relative' }}>
      <div ref={callerRef} style={{ userSelect: 'none' }}>
        <CurrentWeek week={week} />
      </div>

      {isOpen && (
        <div ref={modalRef}>
          <CalendarModal
            week={week}
            onClose={() => setIsOpen(false)}
            onApply={(props) => {
              onChange(props);
              setIsOpen(false);
            }}
          />
        </div>
      )}
    </div>
  );
};
